module.exports = __webpack_public_path__ + "img/tile_six.47a11958.png";